import { injectable } from 'tsyringe';
import { authClient } from '@/shared/AuthApiClient';

export interface ManagedUser {
    id: string;
    tenantId: string;
    email: string;
    firstName: string;
    lastName: string;
    displayName: string;
    status: string;
    roles: string[];
    createdAt: string;
}

export interface RoleView {
    id: string;
    name: string;
}

export interface InviteUserInput {
    email: string;
    firstName: string;
    lastName: string;
    roles: string[];
    tenantId?: string;
}

@injectable()
export class UsersAdminService {
    async listUsers(): Promise<ManagedUser[]> {
        const data = await authClient.usersApi.getUsers();
        return data as unknown as ManagedUser[];
    }

    async listRoles(): Promise<RoleView[]> {
        const data = await authClient.rolesApi.getRoles();
        return data as unknown as RoleView[];
    }

    async inviteUser(input: InviteUserInput): Promise<void> {
        await authClient.usersApi.postInvite({ inviteUserPayload: input });
    }

    async setUserRoles(id: string, roles: string[]): Promise<void> {
        await authClient.usersApi.putByIdRole({ id, setUserRolesPayload: { roles } });
    }

    async deleteUser(id: string): Promise<void> {
        await authClient.usersApi.deleteById({ id });
    }
}
